import { createSelector } from 'reselect';

const selectNotifications = (state) => state.get('notifications');

const makeSelectNotificationsList = () =>
  createSelector(selectNotifications, (state) => state.get('list'));

const makeSelectLoading = () =>
  createSelector(selectNotifications, (state) => state.getIn(['network', 'loading']));

const makeSelectError = () =>
  createSelector(selectNotifications, (state) => state.getIn(['network', 'error']));

const makeSelectPolling = () =>
  createSelector(selectNotifications, (state) => state.get('polling', false));

const makeSelectPage = () => createSelector(selectNotifications, (state) => state.get('page', 1));
const makeSelectHasMore = () =>
  createSelector(selectNotifications, (state) => state.get('hasMore', false));

export {
  makeSelectPage,
  makeSelectError,
  makeSelectHasMore,
  makeSelectLoading,
  makeSelectPolling,
  selectNotifications,
  makeSelectNotificationsList,
};
